import { fetchFinance } from "utils/api";

export const queryList = async (params) => {
  return await fetchFinance("/action", {
    action: "getStatement",
    sort: "transactionDate,desc",
    ...params,
  });
};

export const exportCsv = async (params) => {
  return await fetchFinance("/statement/list", {
    output: "csv",
    ...params,
  });
};
